export default __webpack_public_path__ + "static/media/hatch-gribble.f3d11109.mp4";